import React from "react";
import { Lock, Shield, BadgeCheck, Award, Zap, Truck } from "lucide-react";

const PAYMENTS = ["VISA", "MC", "AMEX", "PAYPAL", "APPLE PAY", "GOOGLE PAY"];

export default function TrustBadgesStrip() {
  return (
    <div
      data-testid="trust-badges-strip"
      className="rounded-2xl border border-black/10 bg-[#fafaf8] p-4"
    >
      {/* USA company + Total Security row — primary trust */}
      <div className="grid grid-cols-2 gap-3 text-[11px] text-[#0e0e10] font-bold border-b border-dashed border-black/10 pb-3 mb-3">
        <div className="flex items-center gap-1.5">
          <span aria-hidden className="text-[14px] leading-none">🇺🇸</span>
          Registered US Company
        </div>
        <div className="flex items-center gap-1.5">
          <Shield size={13} className="text-[#22c55e]" /> Total Security checkout
        </div>
        <div className="flex items-center gap-1.5">
          <Truck size={13} className="text-[#0e0e10]" /> Ships from 🇺🇸 USA & 🇪🇺 EU
        </div>
        <div className="flex items-center gap-1.5">
          <Zap size={13} className="text-[#0e0e10]" /> Processed in 24h
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 text-[11px] text-[#3a3a40] font-semibold">
        <div className="flex items-center gap-1.5">
          <Lock size={13} className="text-[#0e0e10]" /> 256-bit SSL secured
        </div>
        <div className="flex items-center gap-1.5">
          <Shield size={13} className="text-[#0e0e10]" /> 100-night sleep trial
        </div>
        <div className="flex items-center gap-1.5">
          <BadgeCheck size={13} className="text-[#0e0e10]" /> Verified by Stripe
        </div>
        <div className="flex items-center gap-1.5">
          <Award size={13} className="text-[#0e0e10]" /> 7-star hotel-grade
        </div>
      </div>

      <div className="mt-3 border-t border-dashed border-black/10 pt-3">
        <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#6b6b72] mb-2">
          Pay with confidence
        </div>
        <div className="flex flex-wrap items-center gap-1.5">
          {PAYMENTS.map((p) => (
            <span
              key={p}
              className="text-[9px] font-extrabold tracking-wider bg-white border border-black/10 text-[#0e0e10] px-2.5 py-1.5 rounded-md"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
